import { ItemListMapper } from '../../infrastructure/utils/implementation/item-list.mapper';
import { IEventCoordinatorDTO } from '../../api/events.dao';

export class CoordinatorItemsMapper extends ItemListMapper<IEventCoordinatorDTO> {
    public static create(initialCoordinatorList: IEventCoordinatorDTO[]): CoordinatorItemsMapper {
        return new CoordinatorItemsMapper(initialCoordinatorList || []);
    }

    public getAddedCoordinatorsToList(list: IEventCoordinatorDTO[]): IEventCoordinatorDTO[] {
        return super.getItemsAddedToList(list, this.initialList);
    }
    public getRemovedCoordinatorsFromList(list: IEventCoordinatorDTO[]): IEventCoordinatorDTO[] {
        return super.getItemsRemovedFromList(list, this.initialList);
    }

    private constructor(private readonly initialList: IEventCoordinatorDTO[]) {
        super('username');
    }
}
